document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-comic-slider]').forEach((slider) => {
    const track = slider.querySelector('.comic-quotes__track');
    const slides = Array.from(slider.querySelectorAll('.comic-quotes__slide'));
    const prevButton = slider.querySelector('.comic-quotes__arrow--prev');
    const nextButton = slider.querySelector('.comic-quotes__arrow--next');
    const section = slider.closest('.comic-quotes');
    const dots = section ? Array.from(section.querySelectorAll('[data-comic-dot]')) : [];

    if (!track || slides.length < 2) return;

    let currentIndex = 0;
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    let autoplayTimer = null;

    const autoplayEnabled = slider.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed, 10) * 1000 || 5000;

    function getGap() {
      return parseFloat(window.getComputedStyle(track).gap) || 0;
    }

    function getSlideWidth() {
      return slides[0].offsetWidth + getGap();
    }

    function getVisibleSlides() {
      return window.innerWidth < 750 ? 1 : 3;
    }

    function getMaxIndex() {
      return Math.max(0, slides.length - getVisibleSlides());
    }

    function equalizeHeights() {
      const bubbles = slider.querySelectorAll('.comic-quotes__bubble');
      let maxHeight = 0;

      bubbles.forEach((bubble) => {
        bubble.style.minHeight = '';
      });

      bubbles.forEach((bubble) => {
        maxHeight = Math.max(maxHeight, bubble.offsetHeight);
      });

      bubbles.forEach((bubble) => {
        bubble.style.minHeight = `${maxHeight}px`;
      });
    }

    function updateSlider() {
      const slideWidth = getSlideWidth();
      const maxIndex = getMaxIndex();

      if (currentIndex > maxIndex) currentIndex = maxIndex;
      if (currentIndex < 0) currentIndex = 0;

      track.style.transform = `translateX(-${currentIndex * slideWidth}px)`;

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentIndex);
      });
    }

    function goNext() {
      const maxIndex = getMaxIndex();
      currentIndex = currentIndex >= maxIndex ? 0 : currentIndex + 1;
      updateSlider();
    }

    function goPrev() {
      const maxIndex = getMaxIndex();
      currentIndex = currentIndex <= 0 ? maxIndex : currentIndex - 1;
      updateSlider();
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled || slides.length <= getVisibleSlides()) return;

      stopAutoplay();

      autoplayTimer = setInterval(() => {
        goNext();
      }, autoplaySpeed);
    }

    nextButton?.addEventListener('click', () => {
      stopAutoplay();
      goNext();
      startAutoplay();
    });

    prevButton?.addEventListener('click', () => {
      stopAutoplay();
      goPrev();
      startAutoplay();
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        stopAutoplay();
        currentIndex = parseInt(dot.dataset.comicDot, 10);
        updateSlider();
        startAutoplay();
      });
    });

    slider.addEventListener('touchstart', (event) => {
      startX = event.touches[0].clientX;
      currentX = startX;
      isDragging = true;
      stopAutoplay();
    }, { passive: true });

    slider.addEventListener('touchmove', (event) => {
      if (!isDragging) return;
      currentX = event.touches[0].clientX;
    }, { passive: true });

    slider.addEventListener('touchend', () => {
      if (!isDragging) return;

      const diff = startX - currentX;

      if (Math.abs(diff) > 45) {
        if (diff > 0) {
          goNext();
        } else {
          goPrev();
        }
      }

      isDragging = false;
      startAutoplay();
    });

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    window.addEventListener('resize', () => {
      equalizeHeights();
      updateSlider();
      startAutoplay();
    });

    setTimeout(() => {
      equalizeHeights();
      updateSlider();
      startAutoplay();
    }, 100);
  });
});